import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Messages from "../pages/messages/page";
import Gifts from "../pages/gifts/page";
import Gallery from "../pages/gallery/page";
import Ajuda from "../pages/ajuda/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/ajuda",
    element: <Ajuda />,
  },
  {
    path: "/caderno-de-recados",
    element: <Messages />,
  },
  {
    path: "/lista-de-presentes",
    element: <Gifts />,
  },
  {
    path: "/galeria",
    element: <Gallery />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
